module.exports = __webpack_public_path__ + "static/mask_lo_020-d6cc7d3384308e7bb73d9ccd0b00e23c.jpg";